import React, { ReactElement, ReactNode } from 'react';

import { RowCollectionLayout } from './types';

export type PlaceholderVariant = 'hero' | 'tall' | 'default';

export const sanitizeLayoutClass = (layoutType: RowCollectionLayout): string =>
  layoutType.replace(/\+/g, '-plus-').replace(/[^a-z0-9-]/gi, '-');

export const buildTilePlaceholder = (
  placeholder: ReactElement,
  key: string,
  variant: PlaceholderVariant = 'default'
): ReactElement => {
  const modifier =
    variant === 'hero'
      ? ' itv-row-collection__tile-placeholder--hero'
      : variant === 'tall'
        ? ' itv-row-collection__tile-placeholder--tall'
        : '';

  return (
    <div key={key} className={`itv-row-collection__tile-placeholder${modifier}`}>
      {React.cloneElement(placeholder, { key: `${key}-content` })}
    </div>
  );
};

export const ensureTileCount = (
  tiles: ReactNode[],
  required: number,
  createPlaceholder: (index: number) => ReactElement
): ReactNode[] => {
  if (tiles.length >= required) {
    return tiles;
  }

  const filled = [...tiles];

  for (let i = tiles.length; i < required; i++) {
    filled.push(createPlaceholder(i));
  }

  return filled;
};
